export function UploadProgress({ file, progress, status }) {
  const statusColors = {
    uploading: 'bg-blue-500',
    processing: 'bg-warning-500',
    ready: 'bg-success-500',
    error: 'bg-error-500',
  };

  const bgColor = statusColors[status] || 'bg-gray-500';

  return (
    <div className="flex items-center gap-3 rounded-lg bg-dark-850 border border-dark-700 p-3">
      <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded bg-dark-800">
        <div className={`h-3 w-3 rounded-full ${bgColor} animate-pulse`}></div>
      </div>
      <div className="flex-1 min-w-0">
        <p className="truncate text-sm font-medium text-dark-100">{file?.name || 'Uploading...'}</p>
        <div className="mt-1 h-1.5 w-full rounded-full bg-dark-700 overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-300 ${status === 'error' ? 'bg-error-500 w-full' : ''}`}
            style={{ width: status === 'ready' || status === 'error' ? '100%' : `${progress}%` }}
          ></div>
        </div>
      </div>
      <span className="text-xs font-medium uppercase text-dark-400">{status}</span>
    </div>
  );
}

export function UploadProgressList({ uploads }) {
  if (!uploads || uploads.length === 0) return null;
  return (
    <div className="space-y-2 p-4">
      {uploads.map((u) => (
        <UploadProgress key={u.id} file={u.file} progress={u.progress} status={u.status} />
      ))}
    </div>
  );
}
